/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp.  2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../lib/@waca/core-client/js/core-client/utils/dom-utils',
	'jquery',
	'underscore',
	'text!./templates/filterItemAvatar.html',
	'doT'
],
function(BaseClass, DomUtils, $, _, AvatarTemplate, doT) {

	var FilterItemsContainer = BaseClass.extend([], {
		/**
			 * Drag and drop positions
			 */
		DND_DRAG_INDEX_FROM_FILTER_PANEL: -2,

		/**
			 * filter item wraper identifier
			 */
		_filterItemWrapper: 'wa-filterDock-filterItem-top',

		_avatarTemplateFn: doT.template(AvatarTemplate),

		/**
			 * Constructor
			 *
			 * @param {object} options - arguments
			 * @param {object} options.$el - jQuery object represents the FilterItemContainer instance
			 * @param {string} options.id - The id representing this instance
			 * @param {object} options.logger - The logger object use for logging
			 * @param {object} options.dashboardApi  - the dashboard API
			 * @param {object} options.pageContextAPI  - the page context API
			 * @param {object} options.handlers  - the handlers that can be use by this instance
			 *
			 * @constructs FilterItemsContainer
			 * @extends {lib/@waca/core-client/js/core-client/ui/core/Class}
			 */
		init: function(options) {
			FilterItemsContainer.inherited('init', this, arguments);
			this.$el = options.$el;
			this.id = options.id;
			this.dashboardApi = options.dashboardApi;
			this.logger = options.logger;
			this.pageContextAPI = options.pageContextAPI;
			this.handlers = options.handlers;

			//edor-mig: CA doesn't use HTML5 DnD. widgetAddUIHelper is use to
			// is used to setup draggable items. This depend on the HTML5 Dnd
			// service in WA

			//create the widget helper for adding widgets to the canvas
			// this.widgetAddUIHelper = new WidgetAddUIHelper({
			// 	allowedTypes: [this._filterItemWrapper],
			// 	logger: this.logger,
			// 	services: this.services
			// });

			this.avatars = {};

			//Set the id attribute so it can be locate during dnd
			this.$ancestor = this.$el.closest('.filter-dock-middle');
			this.$ancestor.attr('id', this.id);
			this.$ancestor.addClass(this.id);

			this.currentCursor = $('body').css('cursor');
			this._intializeDnD();
		},

		/**
			 * Process when the instance is being destroy
			 */
		destroy: function() {
			if (this.htm5DndSvc) {
				this.htm5DndSvc.unregisterDropZone(this);
				this.htm5DndSvc = null;
			}

			if (this._dndTarget) {
				this._dndTarget.remove();
				this._dndTarget = null;
			}

			if (this.widgetAddUIHelper) {
				this.widgetAddUIHelper.destroy();
			}

			this.avatars = {};
			FilterItemsContainer.inherited('destroy', this, arguments);
		},

		/**
			 * @return {boolean} whether the mouse is hoverinng in correct intended DOM element
			 */
		mouseHoverOverIsValid: function(event) {
			return this.$ancestor && _.isNumber(this.dragStartIndex) && DomUtils.withinElementBoundaries(event, this.$ancestor[0]);
		},

		/**
			 * Cleanup visual display
			 *
			 */
		cleanupVisualDisplay: function() {
			this._removeInsertMarker();
		},

		/**
			 * Process on drag hover over the filter dock
			 *
			 * @param {object} event - the JQuery event object
			 */
		onDragHoverFilterDock: function(dragObject, dropTargetNode, event) {
			//Attempt to insert the filter item from the filter panel
			var position = this.getDropPosition(event);
			var index = position && position.isValid && position.insertBefore ? position.insertBefore.index : null;
			if (_.isNumber(index) || this._isContainerEmpty()) {
				this.dragStartIndex = this.DND_DRAG_INDEX_FROM_FILTER_PANEL;
				this._executeDragOver(event, true, position);
			} else {
				this._removeInsertMarker();
			}
		},

		_isContainerEmpty: function() {
			return this.$el.find('.filterItemWrapper').length === 0;
		},

		/**
		 * Process when the 'dragstart' event triggered on the filter dock item
		 * @param {object} event - the jQuery event object
		 *
		 * @return {boolean} false to request iQuery to invoke event.preventDefault() && event.stopPropagation()
		 */
		onDragStart: function(event) {
			this.cleanupInsertMarker();
			var dragStartIndex = this.$el.find('.filterItemWrapper').index($(event.target).closest('.filterItemWrapper'));

			if (dragStartIndex !== -1) {
				this.dragStartIndex = dragStartIndex;
			}
		},

		/**
		 * 'dragenter' event callback
		 *
		 * @param {object} dragObject - the drag object context
		 * @param {object} node - the dom node
		 * @param {object} event - the jQuery event object
		 *
		 * @return {boolean} false to request iQuery to invoke event.preventDefault() && event.stopPropagation()
		 *
		 */
		onDragEnter: function(dragObject, node, event) {
			event.preventDefault();
			return false;
		},

		/**
		 * 'dragover' event callback
		 *
		 * @param {object} event - the jQuery event object
		 *
		 * @return {boolean} false to request iQuery to invoke event.preventDefault() && event.stopPropagation()
		 *
		 */
		onDragMove: function(dragData, eventName, event) {
			this._updateDragStartIndex(event);

			if (_.isNumber(this.dragStartIndex)) {
				$('body').css('cursor', this.currentCursor);
				this._executeDragOver(event);
			} else {
				this._removeInsertMarker();
				$('body').css('cursor', 'not-allowed');
			}
			return false;
		},

		/**
			 * Execute the dragover event
			 *
			 * @param {object} event - the JQuery event object
			 * @param {boolean} skipPreventDefault - skip calling event.preventDefault boolean flag
			 * @param {object} [position] - the position to insert
			 */
		_executeDragOver: function(event, skipPreventDefault, position) {
			if (this.mouseHoverOverIsValid(event) || this._isContainerEmpty()) {
				if (!skipPreventDefault) {
					event.preventDefault();
				}

				position = position || this.getDropPosition(event);

				if (position && position.isValid && position.insertBefore) {
					var items = this._getItemsInFilterDock();
					this._processDragOver(items, position);
				} else {
					this._removeInsertMarker();
				}

				this._onChevronEnter(event);
			}
		},

		/**
			 * Does the actual processing for the dragover event
			 *
			 * @param {array} items - array of items
			 * @param {object} position - the position where to draw the insert marker
			 */
		_processDragOver: function(items, position) {
			var atIndex = this._calcInsertMarkerLocation(items, position);
			if (atIndex === -1) {
				if (this.showInsertMarker) {
					this._removeInsertMarker();
				}
			} else {
				//Insert marker if and only if the dock already has filter items
				if (position.insertBefore.displayInsertMarker) {
					if (!this.showInsertMarker || position.insertBefore.dndPastEnd) {
						this._renderInsertMarker(items, atIndex, {
							pastBeginOfList: position.insertBefore.index === 0,
							pastEndOfList: position.insertBefore.dndPastEnd
						});
					}
				} else {
					this._removeInsertMarker();
				}
			}
		},

		/**
			 * Calculates and return the location to display the insert marker
			 *
			 * @param {array} items - collection of filter items in the filter dock
			 * @param {object} position - object contains necessary information to calculate the location to display the insert marker
			 *
			 * @return {number} the zero-based index to display the insert marker or -1 if the location is not found
			 */
		_calcInsertMarkerLocation: function(items, position) {
			if (!position || !position.isValid || !position.insertBefore) {
				throw new Error('Invalid position provided when requesting the calculation of the insert marker location');
			}

			var atIndex = -1;
			if (position.insertBefore.index === -1) {
				//User has dragged over to the end of the filter dock list so only display the insert marker only if the
				//dragged filter item is not located at index length -1 since this just means drop at the same location.
				//No need to display the insert marker if drop at the same location
				if (this.dragStartIndex !== items.length - 1) {
					//Add marker to the end of dock list
					atIndex = items.length - 1;
				}
			} else if (this.dragStartIndex !== position.insertBefore.index) {
				atIndex = this._calcInsertMarkerInMiddleOfFilterDock(position);
			}

			return atIndex;
		},

		/**
			 * Calculate the middle position to insert the marker
			 *
			 * @param {object} position - object contains necessary information to calculate the location to display the insert marker
			 *
			 * @return {number} the zero-based index to display the insert marker or -1 if the location is not found
			 */
		_calcInsertMarkerInMiddleOfFilterDock: function(position) {
			var atIndex = -1;
			if ((this.dragStartIndex === this.DND_DRAG_INDEX_FROM_FILTER_PANEL) || (this.dragStartIndex > position.insertBefore.index)) {
				//Start dragging from right to left
				atIndex = position.insertBefore.index;
			} else if (position.insertBefore.displayInsertMarker && position.insertBefore.index - 1 >= this.dragStartIndex) {
				//Start dragging from left to right
				atIndex = position.insertBefore.index;

				if (position.insertBefore.index - 1 === this.dragStartIndex) {
					//When dragging from left to right do not want to show the insert marker at the next location so
					//fake the show insert marker
					this.showInsertMarker = true;
				}
			}
			return atIndex;
		},

		/**
			 * Render and display the insert marker
			 *
			 * @param {array} items - collection of filter items in the filter dock
			 * @param {number} index - valid index location to display the marker
			 * @param {object} [options] - the options to render the insert marker location
			 * @param {boolean} [options.pastBeginOfList] - drag past the beginning of filter dock list
			 * @param {boolean} [options.pastEndOfList] - drag past the end of filter dock list
			 *
			 */
		_renderInsertMarker: function(items, index, options) {
			this._removeInsertMarker();

			if (!options) {
				throw new Error('Invalid options provided when request to render insert marker');
			}

			if (options.pastBeginOfList) {
				if (!this.$beginInsertMarker) {
					this.$beginInsertMarker = this.$ancestor.find('.filterInsertMarker.inFront');
				}
				this.$beginInsertMarker.addClass('showMarker');
			} else if (options.pastEndOfList) {
				var $endMarker = this._getEndInsertMarker();
				$endMarker.addClass('showMarker');

			} else {
				var $node = $(items[index]);
				this.$insertMarker = $node.find('.inMiddle');
				this.$insertMarker.addClass('showMarker');
			}

			this.markerDisplayAtIndex = index;
			this.showInsertMarker = true;
		},

		/**
			 * Removes the insert marker from the DOM
			 */
		_removeInsertMarker: function() {
			this.markerDisplayAtIndex = -1;
			this.showInsertMarker = false;
			if (this.$insertMarker) {
				this.$insertMarker.removeClass('showMarker');
				this.$insertMarker = null;
			}

			if (this.$beginInsertMarker) {
				this.$beginInsertMarker.removeClass('showMarker');
			}

			if (this.$endInsertMarker) {
				this.$endInsertMarker.removeClass('showMarker');
			}
		},

		/**
			 * Process hovering on the chevrons for 'mousemove' an 'touchmove' events
			 *
			 * @param {object} event - the JQuery event object
			 */
		_onChevronEnter: function(event) {
			if (event.type === 'mousemove' || event.type === 'touchmove' || event.type === 'dragover') {
				if (this._canClickOnLeftChevronBoundaries(event)) {
					if (!this.leftChevronIntervalId) {
						this.leftChevronIntervalId = setInterval(function() {
							if (this.leftChevronIntervalId && this._canClickOnLeftChevronBoundaries(event)) {
								this.handlers.chevron.onClickOnLeftChevron();
							} else {
								this.clearIntervals();
							}
						}.bind(this), this.handlers.chevron.delay || 300);
					}
				} else if (this._canClickOnRightChevronBoundaries(event)) {
					if (!this.rightChevronIntervalId) {
						this.rightChevronIntervalId = setInterval(function() {
							if (this.rightChevronIntervalId && this._canClickOnRightChevronBoundaries(event)) {
								this.handlers.chevron.onClickOnRightChevron();
							} else {
								this.clearIntervals();
							}
						}.bind(this), this.handlers.chevron.delay || 300);
					}
				} else {
					this.clearIntervals();
				}
			}
		},

		/**
			 * @return {boolean} indicating whether can click on the left chevron or not
			 */
		_canClickOnLeftChevronBoundaries: function(event) {
			var $leftChevron = this.handlers && this.handlers.chevron ? this.handlers.chevron.getLeftChevron() : null;
			return $leftChevron && !$leftChevron.hasClass('disable') && DomUtils.withinElementBoundaries(event, $leftChevron[0]);
		},

		/**
			 * @return {boolean} indicating whether can click on the right chevron or not
			 */
		_canClickOnRightChevronBoundaries: function(event) {
			var $rightChevron = this.handlers && this.handlers.chevron ? this.handlers.chevron.getRightChevron() : null;
			return $rightChevron && !$rightChevron.hasClass('disable') && DomUtils.withinElementBoundaries(event, $rightChevron[0]);
		},

		/**
			 * Returns the drop postion object
			 *
			 * @param {object} event - the jQuery event
			 *
			 * @return {object} Contains the positon info which the client  can use to determine where to drop the filter item
			 */
		getDropPosition: function(event) {
			var result = {};

			var items = this.$ancestor.find('.filterItemWrapper').get();
			var droppedPosition = this._getDropPosition(event, items);
			if (droppedPosition) {
				result = _.extend(result, droppedPosition);
			}

			return result;
		},

		/**
		 * clears any set timeouts.
		 */
		clearIntervals: function() {
			window.clearInterval(this.rightChevronIntervalId);
			this.rightChevronIntervalId = null;
			window.clearInterval(this.leftChevronIntervalId);
			this.leftChevronIntervalId = null;
		},
		/**
			 * Clean up insert marker
			 */
		cleanupInsertMarker: function() {
			this.dragStartIndex = null;
			this._removeInsertMarker();
		},

		/**
			 * 'drop' event callback
			 *
			 * @param {object} payload - the payload contain info to process the drop event
			 * @param {object} event - jQuery event object
			 * @param {string} dropTargetNode - the target node
			 */
		onDrop: function(payload, dropTargetNode, event) {
			this.cleanupInsertMarker();
			var items = this._getItemsInFilterDock();
			var results = this._getDropPosition(event, items);
			$('body').css('cursor', this.currentCursor);

			if (results.isValid) {
				//Ensure that we are not drag and drop onto the same item
				if (results.insertBefore && results.insertBefore.dockKey) {
					if (results.insertBefore.dockKey === payload.data.dockkey) {
						//Drag and drop onto the same item so cancel the drop
						return;
					}
				}

				//Find the element to insert to a new location
				var elToMove = _.find(items, function(item) {
					return this._getDockKey($(item)) === payload.data.dockkey;
				}.bind(this));

				if (elToMove) {
					var $elToMove = $(elToMove);
					$elToMove.detach();

					if (results.insertBefore && results.insertBefore.item && results.insertBefore.dockKey) {
						var node = this._getFilterItemNode(results.insertBefore.dockKey);
						$elToMove.insertBefore(node);
					} else {
						var $endMarker = this._getEndInsertMarker();
						$elToMove.insertBefore($endMarker);
					}
					this.pageContextAPI.reOrderPageContextItems(this.handlers.getFilterItem(payload.data.dockkey), results.insertBefore.item);
				}
			}
		},

		_getFilterItemNode: function(dockKey) {
			return this.$el.find('[data-dockkey="' + _.escape(dockKey) + '"]').get();
		},

		/**
			 * Returns the dnd payload
			 *
			 * @param {object} payload - the payload contain info to process the drop event
			 * @param {string} options.data - the string represents the data being dropped
			 *
			 * @return {object} a promise containing data for use in drag and drop
			 */
		getDnDPayload: function(data) {
			return Promise.resolve({
				data: data
			});
		},

		/**
			 * Initialize drag and drop
			 */
		_intializeDnD: function() {

			var accepts = function(dragObject) {
				return dragObject && dragObject.type === 'wa-filterDock-filterItem-top';
			};
			const DndManager = this.dashboardApi.getFeature('DashboardDnd.internal');
			this._dndManager = DndManager;
			this._dndTarget = this._dndManager.addDropTarget(this.$ancestor, {
				accepts: accepts.bind(this),
				onDrop: this.onDrop.bind(this),
				onDragEnter: this.onDragEnter.bind(this),
				onDragMove: this.onDragMove.bind(this)
			});

			this.$ancestor.on('mousedown dragleft dragright', {
				itemContainer: this
			}, function(event) {
				if ($(event.target).hasClass('wa-filterDock-filterItem-top') || $(event.target.parentNode).hasClass('wa-filterDock-filterItem-top')) {

					event.data.itemContainer.onDragStart(event);
					this._dndManager.startDrag({
						event: event,
						avatar: event.data.itemContainer._getAvatar($(event.target)),
						type: 'wa-filterDock-filterItem-top',
						data: event.data.itemContainer._getEntry(event),
						moveXThreshold: 15,
						moveYThreshold: 15
					});
				}
			}.bind(this));
		},



		/**
			 * Gets the dnd entry info
			 *
			 * @param {object} event - jQuery event object
			 *
			 * @return {object} the entry info object
			 */
		_getEntry: function(event) {
			var $target = $(event.target).closest('.filterItemWrapper');
			var dockkey = this._getDockKey($target);

			return {
				dockkey: dockkey,
				options: this._getAvatar($target)
			};
		},

		/**
			 * Returns the dock key for the jQuery element
			 *
			 * @param {object} $el - the jQuery element
			 *
			 * @return {string} the dock key string
			 */
		_getDockKey: function($el) {
			return ($el instanceof $) ? _.unescape($el.closest('.filterItemWrapper').data('dockkey')) : '';
		},

		/**
			 * Returns
			 *
			 * @param {object} $el - the jQuery element
			 *
			 * @return {string} the dock key string
			 */
		_getAvatarContext: function($el) {
			var ctx = {};

			if ($el instanceof $) {
				ctx.itemName = $el.closest('.filterItemWrapper').find('.wa-filterDock-filterName').text();
				ctx.itemBoundingClientRect = $el.get()[0].getBoundingClientRect();
			}
			return ctx;
		},

		/**
			 * Gets the avatar definition to use for drag and drop
			 *
			 * @param {object} filterItem - the filterItem $ Object
			 *
			 * @return {object} the avatar object defintion
			 */
		_getAvatar: function(filterItem) {

			var dockkey = this._getDockKey(filterItem);

			if (dockkey && !(dockkey in this.avatars)) {

				var $avatar = $(this._avatarTemplateFn(this._getAvatarContext(filterItem)));

				//Fix the stickiness cursor: pointer for FireFox browser
				//causing the avatar to have the pointer cursor while dragging the avatar
				//strip out the cursor when create the avatar
				// var $inDock = $container.find('.inDock');
				// if ($inDock.length > 0) {
				// 	$inDock.removeClass('inDock');
				// }

				this.avatars[dockkey] = $avatar;
			}

			return this.avatars[dockkey];
		},

		/**
			 * Gets the drag and drop dropped position
			 *
			 * @param {object} event - jQuery event object
			 * @param {array} items - array of filterItemWrapper objects
			 *
			 * @return {object} the position where the dropped occur
			 */
		_getDropPosition: function(event, items) {
			var results = {};

			if (!event) {
				return results;
			}

			var pos = this._getMousePosition(event);
			var pageX = pos.pageX;
			var pageY = pos.pageY;
			var parentRect = this.$el[0].getBoundingClientRect();

			if (!items || items.length === 0) {
				results.isValid = true;
				return results; //Drop occurs when filter docker is empty
			}

			var ancestorRect = this.$ancestor[0].getBoundingClientRect();

			//Drop out of bound horizontally/vertically visible boundary so return
			var visibleRect = $(items[0]).find('.wa-filterDock-filterName')[0].getBoundingClientRect();
			if (pageY < visibleRect.top || pageY > visibleRect.bottom || pageX < ancestorRect.left || pageX > ancestorRect.right) {
				//Out of visible boundary so return
				return results;
			}


			results.isValid = true;

			var rect;
			if (pageX < parentRect.left && pageX >= ancestorRect.left) {
				//This this case insert before the first filter item, drop outside of parentRect but still within boundary of ancestorRect
				var firstItem = items[0];
				rect = firstItem.getBoundingClientRect();

				//display the insert marker only if the first item is visible
				var firstItemPartialOrAllVisible = pageX <= rect.right;
				var dockKey = this._getDockKey($(items[0]));
				results.insertBefore = {
					item: this.handlers.getFilterItem(dockKey),
					dockKey: dockKey,
					index: 0,
					displayInsertMarker: firstItemPartialOrAllVisible
				};
			} else if (pageX >= parentRect.right && pageX <= ancestorRect.right) {
				var $lastItem = $(items[items.length - 1]);
				rect = $lastItem[0].getBoundingClientRect();
				var width = rect.right + parseInt($lastItem.css('margin-left'), 10) + parseInt($lastItem.css('margin-right'), 10);

				//display the insert marker only if the last item is visible
				var lastItemPartialOrAllVisible = pageX >= rect.left && pageX <= width;

				//Is the drop positions locate at end outside of parentRect but still within boundary of ancestorRect
				results.insertBefore = {
					item: null,
					dockKey: null,
					index: -1,
					dndPastEnd: true,
					displayInsertMarker: lastItemPartialOrAllVisible
				};
			} else {
				//Calculate actual position to drop
				results = _.extend(results, this._findMiddleDroppedPositonForDnd(items, parentRect, ancestorRect, pageX));
			}

			return results;
		},

		/**
			 * Returns a boolean indicating whether the cursor position is within 3/4 of the element starting from the element's left position
			 *
			 * @param {number} pageX - the x cursor position to verify
			 * @param {object} boundRect - the bound rect to Verify
			 *
			 * @return {boolean} true if the x cursor position is within the 3/4 limit else return false
			 */
		_isWithinThreeQuartersOfElementLeftRightBoundary: function(pageX, boundRect) {
			var quarter = Math.round((boundRect.right - boundRect.left) / 4);
			return pageX >= Math.round(boundRect.left) && pageX <= Math.round(boundRect.left + 3 * quarter);
		},

		/**
			 * Find and return the position that was dropped in the middle of the filterItemWrapper list
			 *
			 * @param {array} items - array of filterItemWrapper objects
			 * @param {object} parentRect - the parent bounding client rect	to be use in calculation
			 * @param {object} ancestorRect - the ancestor bounding client rect	to be use in calculation
			 * @param {number} pageX - the page x location relative to the document
			 *
			 * @return {object} The calculated position object in the middle of the array list
			 */
		_findMiddleDroppedPositonForDnd: function(items, parentRect, ancestorRect, pageX) {
			// Loop through items and find the position to insert
			var index = 0;
			var rect1, rect2;
			var length = items.length;
			var displayInsertMarker;

			for (; index < length; index++) {
				rect1 = items[index].getBoundingClientRect();
				rect2 = (index + 1 < length) ? items[index + 1].getBoundingClientRect() : undefined;

				if (rect2 && pageX >= rect1.right && pageX <= rect2.left) {
					//The x cursor position resides between 2 filter items
					index = index + 1;
					displayInsertMarker = true;
					break;
				} else if (this._isWithinThreeQuartersOfElementLeftRightBoundary(pageX, rect1)) {
					//The x cursor is on top of the element and the position is within 2/3 for the element starting from the element's left
					displayInsertMarker = true;
					break;
				} else if (pageX <= rect1.right) {
					//The cursor is within the element
					break;
				}
			}

			//Valid either:
			//1. Found the middle position to insert where bFound is true OR
			//2. Still within boundary of parentRect.right and ancestorRect.right
			var bFound = index < length;
			var isValid = (bFound || pageX <= ancestorRect.right);

			return {
				isValid: isValid,
				insertBefore: bFound ? {
					item: this.handlers.getFilterItem(this._getDockKey($(items[index]))),
					dockKey: this._getDockKey($(items[index])),
					index: index,
					displayInsertMarker: displayInsertMarker
				} : {
					item: null,
					dockKey: null,
					index: -1,
					dndPastEnd: true,
					displayInsertMarker: true
				}
			};
		},

		/**
			 * Gets the position
			 *
			 * @param {object} event  The iQuery event
			 *
			 * @return {object} The position object
			 *
			 */
		_getMousePosition: function(event) {
			if ($.fn.supportTouch) {
				var changedTouches = event.originalEvent.changedTouches;
				if (changedTouches.length > 0) {
					return {
						pageX: changedTouches[0].pageX,
						pageY: changedTouches[0].pageY
					};
				}
			}

			return {
				pageX: event.originalEvent.pageX,
				pageY: event.originalEvent.pageY
			};
		},

		/**
			 * @return {array} of filter items display in filter dock
			 */
		_getItemsInFilterDock: function() {
			return this.$el.find('.filterItemWrapper').get();
		},

		/**
			 * Updates the dragStartIndex
			 *
			 * @param {object} event - the JQuery event
			 */
		_updateDragStartIndex: function(event) {
			if (!_.isNumber(this.dragStartIndex) && event.originalEvent && event.originalEvent.dataTransfer) {
				var dataTransfer = event.originalEvent.dataTransfer;
				if (dataTransfer && event.originalEvent.dataTransfer.types.length > 0 && event.originalEvent.dataTransfer.types[0].toLowerCase() === 'filteritem') {
					//Drag from filter panel to filter dock
					this.dragStartIndex = this.DND_DRAG_INDEX_FROM_FILTER_PANEL;
				}
			}
		},

		/**
			 * Gets the end insert marker JQuery node
			 *
			 * @return {object} The JQuery dom node
			 */
		_getEndInsertMarker: function() {
			if (!this.$endInsertMarker) {
				this.$endInsertMarker = this.$ancestor.find('.filterInsertMarker.atBack');
			}

			return this.$endInsertMarker;
		}

	});

	return FilterItemsContainer;
});
